module.exports = __webpack_public_path__ + "static/media/ml3.bd7b9ef2.jpg";